/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { SurrenderZone } from 'solis/claude/action';
import useBoardContext from 'solis/claude/action/context/board';

import AuthorityCard from 'solis/claude/card/authority';
import SectorCard from 'solis/claude/card/sector';
import ZoneInfo from 'solis/claude/card/zone';

import ZoneTimeline from 'solis/logic/board/zone/timeline';


export default () =>
{
  const context = useBoardContext();

  const { board, zone, account } = context;

  const zoneTimeline = zone !== null ? ZoneTimeline.create(zone) : null;

  return (
    <Flex direction = 'column' gap = '4' p = '4'>

      <AuthorityCard board = {board} account = {account} />

      {zone !== null && <SectorCard sector = {zone.getSector()} />}
      {zone !== null && <ZoneInfo key = {zone.getAbsoluteHex()} board = {board} zone = {zone} zoneTimeline = {zoneTimeline} />}

      <SurrenderZone context = {context} />

    </Flex>
  );
};
